import type { BombiixCellRendererParams } from '../../../../Components/BombiixAGGrid';
import { NewCheckbox } from '../../../../Components/PIM/common/NewCheckbox';
import { TableRow } from './types';

type SelectionCellProps = BombiixCellRendererParams<TableRow> & {
  selectedIds?: string[];
  onToggle?: (id: string, checked: boolean) => void;
  /** Locked while a bulk edit is open — the selection is what those open rows were built from. */
  disabled?: boolean;
};

/** Resolve the selection id for a row (cluster id if present, else the product id). */
const rowSelectionId = (row: TableRow | undefined): string => {
  if (!row) return '';
  /* A reorder child stands for itself: its parent's clusterId would tick the whole cluster. */
  if (row.__isReorder) return String(row._id ?? '');
  const product = row.__product as { clusterId?: string; _id?: string } | undefined;
  return String(product?.clusterId ?? row._id ?? '');
};

/**
 * Per-row selection checkbox for the table view. Hidden only on the inline add/edit row (draft):
 * every persisted product is selectable, cluster reorder children included — they are products in
 * their own right and can be edited without their parent.
 */
function SelectionCell(params: SelectionCellProps) {
  const { data, selectedIds = [], onToggle, disabled = false } = params;
  if (!data || data._id === '__new__') return null;

  const id = rowSelectionId(data);
  const checked = selectedIds.includes(id);

  return (
    <NewCheckbox
      size="sm"
      className="ptv-select-checkbox"
      aria-label="Select row"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onToggle?.(id, e.target.checked)}
    />
  );
}

export default SelectionCell;
